import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBInputGroup,
  MDBDatepicker,
  MDBSelect,
  MDBDatatable,
  MDBIcon,
  MDBPopconfirm, MDBPopconfirmMessage,
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';

import moment from 'moment';
import Alert from './sub/dialog'
import Billitemlist from './sub/billitemlist'


import { Stack, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';


const Component = () => {
  const alert = useRef();
    const navigate = useNavigate();
  
  const setError = (message,ismessage) => (ismessage?alert.current.showmessage(message): alert.current.showerror(message));

  useEffect(() => {
    // Get the token from sessionStorage


    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }

  }, []);

  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={alert} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='10'>
                  <h4>จัดการรายการบริการ</h4>
                </MDBCol>

              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>
              <Billitemlist  setError={setError} />

            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>



    </MDBContainer>
  </>);
};

export default Component;
